module.exports = __webpack_public_path__ + "img/shadow.0545d0a5.png";